import * as Types from '../types';

export const createGDCurrentUserRepository = (getGDService: Types.GetGDService): Types.GDCurrentUserRepository => ({
    async get(params) {
        const { product } = params;
        const { getBackend } = await getGDService({ product });
        return getBackend().currentUser().getUser();
    },
    async getPermissions(params) {
        const { product, testingWorkspaceId } = params;
        const { getBackend, getWorkspace } = await getGDService({ product });
        return getBackend()
            .workspace(testingWorkspaceId || getWorkspace() || '')
            .permissions()
            .getPermissionsForCurrentUser();
    },
});
